require('./myClipsController');
require('../../../../shared/clipSearch/filterDirective/filterDirective');

angular.module('app.admin.videoAnalysis.tabs.myClips', [
  'app.admin.videoAnalysis.tabs.myClips.myClipsController',
  'app.shared.clipSearch.filterDirective',
])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      "use strict";

      $stateProvider.state(
        'app.admin.videoAnalysis.myClips',
        {
          url: '/my-clips?:filter',
          templateUrl: 'components/admin/videoAnalysis/tabs/myClips/myClipsView.html',
          controller: 'app.admin.videoAnalysis.tabs.myClips.myClipsController',
          isChildState: true,
          tabName: 'myClips',
          params: {
            preset: null,
            submitted:null,
            //selected_clip: null
          }
        }
      )
        .state(
          'app.admin.videoAnalysis.starredClips',
          {
            url: '/starred-clips?:filter',
            templateUrl: 'components/admin/videoAnalysis/tabs/myClips/myClipsView.html',
            controller: 'app.admin.videoAnalysis.tabs.myClips.myClipsController',
            isChildState: true,
            tabName: 'starredClips',
            filterOverride: {starred: 'starred'},
            params: {
              preset: null,
              submitted:null,
            }
          }
        );
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/tabs/myClips/myClips.js